import { render } from "./PlannedShutdownBanner.vue?vue&type=template&id=2a5db090&scoped=true"
import script from "./PlannedShutdownBanner.vue?vue&type=script&lang=js"
export * from "./PlannedShutdownBanner.vue?vue&type=script&lang=js"

import "./PlannedShutdownBanner.vue?vue&type=style&index=0&id=2a5db090&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5db090"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon});
